define('classes/templator',['underscore', 'backbone', 'text!templates/templates.html'],
  function(_, Backbone, templates) {
    var $templates = $(templates);
    return {
      menu: _.template($templates.filter('#menu-template').html()),
      pagination: _.template($templates.filter('#pagination-template').html()),
      restaurantMap: _.template($(templates).filter('#restaurant-map-template').html()),
      restaurantSearchResult: _.template($(templates).filter('#restaurant-search-result-template').html()),
      priceRangeTemplate: _.template($(templates).filter('#price-range-template').html()),
      suggestions: _.template($(templates).filter('#suggestions-template').html()),
      reviews: _.template($(templates).filter('#reviews-template').html())
    }
  }
);
